export class ArticleNumberUtils {
  public static compareArticleNumbers(articleNumber1: string, articleNumber2: string): number {
    const aHasSlash = articleNumber1.includes("/");
    const bHasSlash = articleNumber2.includes("/");

    if (aHasSlash && !bHasSlash) {
      return 1;
    } else if (!aHasSlash && bHasSlash) {
      return -1;
    } else {
      return articleNumber1.localeCompare(articleNumber2, undefined, {numeric: true, sensitivity: 'base'});
    }
  }

  public static compareArticleNumbersDesc(articleNumber1: string, articleNumber2: string): number {
    const aHasSlash = articleNumber1.includes("/");
    const bHasSlash = articleNumber2.includes("/");

    if (aHasSlash && !bHasSlash) {
      return 1;
    } else if (!aHasSlash && bHasSlash) {
      return -1;
    } else {
      return articleNumber2.localeCompare(articleNumber1, undefined, {numeric: true, sensitivity: 'base'});
    }
  }
}
